import ccm from '../../public/ccm'
import { API_IP, API_PORT } from '../constants'

const myfunction = {
  getip: function () {
    if (process.env.NODE_ENV === 'development') {
      const ConfigManager = window.ConfigManager
      const config = ConfigManager.getConfig()
      if (config && config.url) {
        return config.url
      }
    }
    return API_IP || window.location.hostname || 'localhost'
  },
  getport: function () {
    const ConfigManager = window.ConfigManager

    const config = ConfigManager.getConfig()
    if (!config) return '8080'

    const protocol = window.location.protocol
    return protocol === 'https:' ? config.httpsPort : API_PORT
  },
  getFullUrl: function (type, endpoint = '') {
    const protocol = window.location.protocol
    const host = this.getip()
    const port = this.getport()

    let url = `${protocol}//${host}:${port}`

    if (type) {
      url += `/${type}`
    }

    if (endpoint) {
      url += `/${endpoint}`
    }

    return url
  },

  getFullDomainUrl: function () {
    return this.getFullUrl() + '/Domain/CheckDomain'
    //return "https://ms06.trackingmate.com:18888/api/Domain/CheckDomain";
  },

  gethttp: function () {
    const protocol = window.location.protocol
    const host = this.getip()
    const port = this.getport()

    let url = `${protocol}//${host}:${port}/`
    return url || 'http://localhost:8080/'
  },
}

export default myfunction
